import React, { useState, useEffect } from 'react'
import { Layout, Typography } from 'antd'
import './Dashboard.scss'
import routes from '../../Routes'
import { Route, BrowserRouter } from 'react-router-dom'

const { Title } = Typography
const { Header, Content, Footer } = Layout

export default function Dashboard () {
  const [title, setTitle] = useState('Dashboard')

  const urlSearchParams = new URLSearchParams(window.location)
  const params = Object.fromEntries(urlSearchParams.entries()).pathname
  useEffect(() => {
    switch (params) {
      case '/login':
        document.title = `${process.env.REACT_APP_TITLE} - 會員登入`
        setTitle('棉花田帳號登入')
        break
      case '/register':
        setTitle('會員註冊/開通')
        break
      case '/register/smsverification':
        setTitle('會員註冊/開通')
        break
      case '/forgetPassword':
        setTitle('忘記密碼')
        break
      case '/forgetPassword/resetPassword':
        setTitle('忘記密碼')
        break
      default:
        setTitle('')
    }
  })
  return (
    <>
      <Layout>
        <Header />
        <Content>
          <Title level={3} className="left-border-title">{title}</Title>
          <div className="component-wrapper">
            {/* components should put here.         */}
            <BrowserRouter forceRefresh={true}>
              {routes.map(singleRoute => {
                const { exact, key, path, ...otherProps } = singleRoute
                return (
                  <Route exact={exact !== false}
                    key={singleRoute.path}
                    path={path}
                    {...otherProps}
                  />
                )
              })}
            </BrowserRouter>
          </div>
        </Content>
        <Footer />
      </Layout>
    </>
  )
}
